import config from '@/config'
import { getItem, notify } from "@/utils";

const { wsURL, tokenName } = config
let ws
let alive = false

// 创建webSocket
export function createWebsocket() {
	if(ws && ws.readyState === ws.OPEN) return ws
	try {
		if (!('WebSocket' in window)) return notify.error("當前瀏覽器不支持websocket")
		ws = new WebSocket(wsURL, [encodeURIComponent(getItem(tokenName))]);
		initEventHandle(ws);
		alive = true
	} catch (e) {
		alive = false
		setTimeout(() => {
			reconnect();
		}, 10000)
	}
	return ws
}


// 心跳检测
const heartCheck = {
	timeout: 60 * 1000,
	timer: null,
	serverTimer: null,
	reset: function () {
		clearTimeout(this.timer);
		return this;
	},
	start: function () {
		const _this = this
		this.timer && clearTimeout(this.timer);
		this.serverTimer && clearTimeout(this.serverTimer);
		this.timer = setTimeout(function () {
			ws.send("ping")
			// 心跳时间内收不到消息，主动触发连接关闭，开始重连
			_this.serverTimer = setTimeout(function () {
				ws.close()
			}, _this.timeout);
		}, this.timeout)
	}
}

// 初始化事件
function initEventHandle(ws) {

	ws.onclose = function (){
		clearTimeout(heartCheck.timer)
		clearTimeout(heartCheck.serverTimer)
		// 非主动关闭同样重连
		if(alive) reconnect()
	}

	ws.onopen = function () {
		heartCheck.reset().start();
	};

	ws.onmessage = function (msg) {
		heartCheck.reset().start();
		if (msg.data === "pong") return
		let data = msg.data
		let type
		try {
			data = JSON.parse(msg.data);
			type = data.type
		} catch (e) {
			type = 'socketupdate'
		}
		const event = new MessageEvent(type , {data: data})
		window.dispatchEvent(event)
	};
}

// 重连
function reconnect() {
	if (reconnect.lock) return;
	reconnect.lock = true;
	setTimeout(function () {
		createWebsocket();
		reconnect.lock = false;
	}, 2000);
}

// 主动销毁(只能调这个方法断开连接，其他情况close需要重连)
export function dispose(){
	alive = false
	ws && ws.close()
	ws = null
}
